import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, vModelText as _vModelText, vModelSelect as _vModelSelect, withKeys as _withKeys, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-142a1e5b")

_pushScopeId("data-v-142a1e5b")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "text-md-right" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left" }, null, -1)
const _hoisted_7 = { class: "table-dropdown" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_9 = {
  key: 1,
  ref: "table"
}
const _hoisted_10 = { class: "text-right p-3" }
const _hoisted_11 = /*#__PURE__*/_createVNode("i", { class: "fa fa-check" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "card"
}
const _hoisted_13 = { class: "table-responsive my-2 font-12 with-line-item" }
const _hoisted_14 = { class: "table table-bordered  mb-0" }
const _hoisted_15 = { class: "table-primary nowrap-text" }
const _hoisted_16 = {
  width: "10%",
  scope: "col"
}
const _hoisted_17 = {
  width: "10%",
  scope: "col"
}
const _hoisted_18 = { class: "form-check pl-0" }
const _hoisted_19 = {
  class: "form-check-label ml-3",
  for: "defaultCheck1"
}
const _hoisted_20 = { scope: "col" }
const _hoisted_21 = { class: "form-check pl-0" }
const _hoisted_22 = {
  class: "form-check-label ml-3",
  for: "defaultCheck2"
}
const _hoisted_23 = { scope: "col" }
const _hoisted_24 = { class: "form-check pl-0" }
const _hoisted_25 = {
  class: "form-check-label ml-3",
  for: "defaultCheck3"
}
const _hoisted_26 = { scope: "col" }
const _hoisted_27 = { class: "form-check pl-0" }
const _hoisted_28 = {
  class: "form-check-label ml-3",
  for: "defaultCheck2"
}
const _hoisted_29 = { scope: "col" }
const _hoisted_30 = { class: "form-check pl-0" }
const _hoisted_31 = {
  class: "form-check-label ml-3",
  for: "defaultCheck2"
}
const _hoisted_32 = { scope: "col" }
const _hoisted_33 = { class: "form-check pl-0" }
const _hoisted_34 = {
  class: "form-check-label ml-3",
  for: "defaultCheck4"
}
const _hoisted_35 = { scope: "col" }
const _hoisted_36 = { class: "form-check pl-0" }
const _hoisted_37 = {
  class: "form-check-label ml-3",
  for: "defaultCheck6"
}
const _hoisted_38 = { scope: "col" }
const _hoisted_39 = { class: "form-check pl-0" }
const _hoisted_40 = {
  class: "form-check-label ml-3",
  for: "defaultCheck4"
}
const _hoisted_41 = { scope: "col" }
const _hoisted_42 = { class: "form-check pl-0" }
const _hoisted_43 = {
  class: "form-check-label ml-3",
  for: "defaultCheck5"
}
const _hoisted_44 = { scope: "col" }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "dropdown-wrap unit-dropdown position-relative" }
const _hoisted_48 = { class: "mr-3" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "dropdown-menu custom-scroll table-dropdown" }
const _hoisted_51 = { class: "dropdown-actions" }
const _hoisted_52 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { class: "d-flex" }
const _hoisted_56 = { class: "control-wrap" }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "dropdown-wrap position-relative" }
const _hoisted_59 = {
  key: 0,
  class: "dropdown-toggle btn-sm bg-light h-100 rounded-0",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_60 = { class: "mr-3" }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "dropdown-menu" }
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { class: "text-nowrap" }
const _hoisted_65 = { class: "item-desc" }
const _hoisted_66 = { class: "text-nowrap" }
const _hoisted_67 = /*#__PURE__*/_createVNode("i", { class: "fa fa-copy" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_69 = { class: "shadow-none" }
const _hoisted_70 = {
  colspan: 8,
  class: "text-right"
}
const _hoisted_71 = { colspan: 3 }
const _hoisted_72 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus mr-1" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Add more item")
const _hoisted_74 = /*#__PURE__*/_createVNode("div", { class: "row" }, null, -1)
const _hoisted_75 = {
  key: 1,
  class: "my-3"
}
const _hoisted_76 = { key: 2 }
const _hoisted_77 = {
  key: 3,
  class: "bg-light rounded p-3 border mt-3"
}
const _hoisted_78 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_79 = {
  key: 0,
  class: "company-logo-wrap border p-1 rounded my-3 bg-white"
}
const _hoisted_80 = { class: "tab-wrap bg-white rounded px-3 pb-3 border" }
const _hoisted_81 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_82 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_83 = {
  class: "nav-link active",
  id: "Contract-tab",
  "data-toggle": "tab",
  "data-target": "#Contract",
  type: "button",
  role: "tab",
  "aria-controls": "Contract",
  "aria-selected": "true"
}
const _hoisted_84 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_85 = {
  class: "nav-link",
  id: "Contract1-tab",
  "data-toggle": "tab",
  "data-target": "#Contract1",
  type: "button",
  role: "tab",
  "aria-controls": "Contract1",
  "aria-selected": "false"
}
const _hoisted_86 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_87 = {
  class: "tab-pane fade show active",
  id: "Contract",
  role: "tabpanel",
  "aria-labelledby": "Contract-tab"
}
const _hoisted_88 = {
  class: "tab-pane fade",
  id: "Contract1",
  role: "tabpanel",
  "aria-labelledby": "Contract1-tab"
}
const _hoisted_89 = { class: "inline-items mt-3" }
const _hoisted_90 = {
  key: 0,
  class: "form-group"
}
const _hoisted_91 = { class: "signature-wrap" }
const _hoisted_92 = { class: "form-group" }
const _hoisted_93 = { class: "inline-items" }
const _hoisted_94 = { class: "upload-btn-wrapper" }
const _hoisted_95 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_96 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_97 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eraser" }, null, -1)
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { class: "upload-btn-wrapper" }
const _hoisted_100 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_101 = { class: "form-wrap mt-2" }
const _hoisted_102 = { class: "form-group mb-2" }
const _hoisted_103 = { class: "d-flex align-items-center mb-2" }
const _hoisted_104 = {
  for: "",
  class: "mr-2 mb-0"
}
const _hoisted_105 = { class: "accordion-wrap mb-3" }
const _hoisted_106 = { class: "card-header bg-white p-0 border-0" }
const _hoisted_107 = { class: "mb-0" }
const _hoisted_108 = /*#__PURE__*/_createVNode("strong", null, "Choose Members", -1)
const _hoisted_109 = {
  id: "chooseMembersCollapse",
  class: "collapse bg-light rounded border my-2"
}
const _hoisted_110 = { class: "bordered-tab-wrap" }
const _hoisted_111 = {
  class: "nav nav-tabs",
  id: "myTab3",
  role: "tablist"
}
const _hoisted_112 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_113 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_114 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_115 = { class: "tab-content" }
const _hoisted_116 = { class: "form-group inline-items my-2 align-middle" }
const _hoisted_117 = /*#__PURE__*/_createTextVNode("Filter")
const _hoisted_118 = /*#__PURE__*/_createVNode("option", { value: "channel" }, "From Channel", -1)
const _hoisted_119 = /*#__PURE__*/_createVNode("option", { value: "member" }, "From Member", -1)
const _hoisted_120 = { class: "row" }
const _hoisted_121 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_122 = { class: "rounded border mb-2" }
const _hoisted_123 = { class: "px-3" }
const _hoisted_124 = { class: "row align-items-center" }
const _hoisted_125 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createVNode("h3", { class: "title" }, [
    /*#__PURE__*/_createVNode("strong", null, "Channels")
  ])
], -1)
const _hoisted_126 = { class: "col-md-8" }
const _hoisted_127 = { class: "search-wrap  my-1" }
const _hoisted_128 = { class: "search-ico" }
const _hoisted_129 = /*#__PURE__*/_createVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_130 = { key: 0 }
const _hoisted_131 = /*#__PURE__*/_createVNode("span", { class: "text-muted" }, "No channels found.", -1)
const _hoisted_132 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_133 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_134 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading channels...", -1)
const _hoisted_135 = { class: "col-md-9" }
const _hoisted_136 = { class: "rounded border mb-2" }
const _hoisted_137 = { class: "px-3" }
const _hoisted_138 = { class: "row align-items-center" }
const _hoisted_139 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createVNode("h3", { class: "title" }, [
    /*#__PURE__*/_createVNode("strong", null, "Members")
  ])
], -1)
const _hoisted_140 = { class: "col-md-8" }
const _hoisted_141 = { class: "search-wrap  my-1" }
const _hoisted_142 = { class: "search-ico" }
const _hoisted_143 = /*#__PURE__*/_createVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_144 = { key: 0 }
const _hoisted_145 = {
  key: 1,
  class: "text-muted text-center"
}
const _hoisted_146 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_147 = { class: "form-group inline-items my-2 align-middle" }
const _hoisted_148 = /*#__PURE__*/_createTextVNode("Filter")
const _hoisted_149 = /*#__PURE__*/_createVNode("option", { value: "channel" }, "From Channel", -1)
const _hoisted_150 = /*#__PURE__*/_createVNode("option", { value: "member" }, "From Member", -1)
const _hoisted_151 = { class: "row" }
const _hoisted_152 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_153 = { class: "rounded border mb-2" }
const _hoisted_154 = { class: "px-3" }
const _hoisted_155 = { class: "row align-items-center" }
const _hoisted_156 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createVNode("h3", { class: "title" }, [
    /*#__PURE__*/_createVNode("strong", null, "Projects")
  ])
], -1)
const _hoisted_157 = { class: "col-md-8" }
const _hoisted_158 = { class: "search-wrap  my-1" }
const _hoisted_159 = { class: "search-ico" }
const _hoisted_160 = /*#__PURE__*/_createVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_161 = { key: 0 }
const _hoisted_162 = /*#__PURE__*/_createVNode("span", { class: "text-muted" }, "No Projects found.", -1)
const _hoisted_163 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_164 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_165 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading projects...", -1)
const _hoisted_166 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_167 = { class: "rounded border mb-2" }
const _hoisted_168 = { class: "px-3" }
const _hoisted_169 = { class: "row align-items-center" }
const _hoisted_170 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createVNode("h3", { class: "title" }, [
    /*#__PURE__*/_createVNode("strong", null, "Channels")
  ])
], -1)
const _hoisted_171 = { class: "col-md-8" }
const _hoisted_172 = { class: "search-wrap  my-1" }
const _hoisted_173 = { class: "search-ico" }
const _hoisted_174 = /*#__PURE__*/_createVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_175 = { key: 0 }
const _hoisted_176 = /*#__PURE__*/_createVNode("span", { class: "text-muted" }, "No channels found.", -1)
const _hoisted_177 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_178 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_179 = /*#__PURE__*/_createVNode("span", { class: "ml-2" }, "Loading channels...", -1)
const _hoisted_180 = { class: "col-md-6" }
const _hoisted_181 = { class: "rounded border mb-2" }
const _hoisted_182 = { class: "px-3" }
const _hoisted_183 = { class: "row align-items-center" }
const _hoisted_184 = /*#__PURE__*/_createVNode("div", { class: "col-md-4" }, [
  /*#__PURE__*/_createVNode("h3", { class: "title" }, [
    /*#__PURE__*/_createVNode("strong", null, "Members")
  ])
], -1)
const _hoisted_185 = { class: "col-md-8" }
const _hoisted_186 = { class: "search-wrap  my-1" }
const _hoisted_187 = { class: "search-ico" }
const _hoisted_188 = /*#__PURE__*/_createVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_189 = { key: 0 }
const _hoisted_190 = {
  key: 1,
  class: "text-muted text-center"
}
const _hoisted_191 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_192 = { class: "row" }
const _hoisted_193 = { class: "col-md-6" }
const _hoisted_194 = { class: "rounded border my-2 p-3" }
const _hoisted_195 = { class: "form-group row mb-1" }
const _hoisted_196 = /*#__PURE__*/_createVNode("label", {
  for: "firstName",
  class: "col-sm-2 col-form-label"
}, [
  /*#__PURE__*/_createTextVNode(" First Name "),
  /*#__PURE__*/_createVNode("sup", { class: "text-danger" }, "*")
], -1)
const _hoisted_197 = { class: "col-sm-10" }
const _hoisted_198 = {
  key: 0,
  class: "text-danger mt-1"
}
const _hoisted_199 = { class: "form-group row mb-1" }
const _hoisted_200 = /*#__PURE__*/_createVNode("label", {
  for: "lastName",
  class: "col-sm-2 col-form-label"
}, [
  /*#__PURE__*/_createTextVNode(" Last Name "),
  /*#__PURE__*/_createVNode("sup", { class: "text-danger" }, "*")
], -1)
const _hoisted_201 = { class: "col-sm-10" }
const _hoisted_202 = {
  key: 0,
  class: "text-danger mt-1"
}
const _hoisted_203 = { class: "form-group row mb-1" }
const _hoisted_204 = /*#__PURE__*/_createVNode("label", {
  for: "contact",
  class: "col-sm-2 col-form-label"
}, [
  /*#__PURE__*/_createTextVNode(" Email/Phone "),
  /*#__PURE__*/_createVNode("sup", { class: "text-danger" }, "*")
], -1)
const _hoisted_205 = { class: "col-sm-10" }
const _hoisted_206 = {
  key: 0,
  class: "text-danger mt-1"
}
const _hoisted_207 = /*#__PURE__*/_createVNode("div", { class: "form-group mb-0 text-right" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "submit",
    class: "btn default-btn"
  }, "Add")
], -1)
const _hoisted_208 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_209 = { class: "rounded border my-2 p-3" }
const _hoisted_210 = { class: "flex-grow-1" }
const _hoisted_211 = { class: "mb-0" }
const _hoisted_212 = { key: 0 }
const _hoisted_213 = { key: 1 }
const _hoisted_214 = { key: 2 }
const _hoisted_215 = { key: 3 }
const _hoisted_216 = {
  key: 4,
  class: "bg-light p-2 rounded border mb-3 custom-scroll user-cards-list"
}
const _hoisted_217 = /*#__PURE__*/_createVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createVNode("label", { for: "" }, "Selected Members")
], -1)
const _hoisted_218 = { class: "row mx-n2" }
const _hoisted_219 = { class: "shadowed-card bg-white h-100 p-2 user-card" }
const _hoisted_220 = /*#__PURE__*/_createVNode("i", { class: "fa fa-user" }, null, -1)
const _hoisted_221 = { class: "row mx-n2" }
const _hoisted_222 = {
  key: 0,
  class: "col-xl-6 px-2"
}
const _hoisted_223 = /*#__PURE__*/_createVNode("i", { class: "fa fa-envelope" }, null, -1)
const _hoisted_224 = {
  key: 1,
  class: "col-xl-6 px-2"
}
const _hoisted_225 = /*#__PURE__*/_createVNode("i", { class: "fa fa-phone" }, null, -1)
const _hoisted_226 = { class: "d-flex align-items-center justify-content-around border-top mt-1 pt-1" }
const _hoisted_227 = { class: "flex-shrink-0 mr-2" }
const _hoisted_228 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, "Notify By")
], -1)
const _hoisted_229 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_230 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bell" }, null, -1)
const _hoisted_231 = /*#__PURE__*/_createTextVNode(" Mail")
const _hoisted_232 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_233 = /*#__PURE__*/_createVNode("i", { class: "fa fa-sms" }, null, -1)
const _hoisted_234 = /*#__PURE__*/_createTextVNode(" SMS")
const _hoisted_235 = { class: "flex-grow-1 text-right" }
const _hoisted_236 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_237 = /*#__PURE__*/_createTextVNode(" Edit")
const _hoisted_238 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" }, null, -1)
const _hoisted_239 = /*#__PURE__*/_createTextVNode(" Delete")
const _hoisted_240 = { class: "row" }
const _hoisted_241 = { class: "col-md-6" }
const _hoisted_242 = { class: "form-wrap mt-2" }
const _hoisted_243 = { class: "form-group" }
const _hoisted_244 = /*#__PURE__*/_createVNode("i", { class: "far fa-comment ml-2" }, null, -1)
const _hoisted_245 = {
  key: 0,
  class: "ml-2 font-weight-bold"
}
const _hoisted_246 = { class: "col-md-6" }
const _hoisted_247 = { class: "form-check pl-0" }
const _hoisted_248 = {
  class: "form-check-label ml-3",
  for: "defaultCheck6"
}
const _hoisted_249 = {
  key: 5,
  class: "error-field-text text-right"
}
const _hoisted_250 = { class: "form-group text-right" }
const _hoisted_251 = {
  href: "#",
  class: "btn default-btn btn-outline",
  "data-toggle": "modal",
  "data-target": "#previewModal"
}
const _hoisted_252 = /*#__PURE__*/_createVNode("i", { class: "fa fa-file-pdf" }, null, -1)
const _hoisted_253 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_254 = {
  class: "modal fade",
  id: "previewModal",
  tabindex: -1,
  "aria-labelledby": "previewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_255 = { class: "modal-dialog" }
const _hoisted_256 = { class: "modal-content" }
const _hoisted_257 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "close ml-auto",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_258 = { class: "modal-body bg-light" }
const _hoisted_259 = { class: "invoice-holder shadowed-box rounded p-3 bg-white" }
const _hoisted_260 = { class: "d-flex" }
const _hoisted_261 = { class: "flex-grow-1" }
const _hoisted_262 = { class: "invoice-logo" }
const _hoisted_263 = { class: "invoice-address" }
const _hoisted_264 = { class: "uppercase-text" }
const _hoisted_265 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_266 = { class: "row" }
const _hoisted_267 = { class: "col-md-3" }
const _hoisted_268 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_269 = { class: "col-md-3" }
const _hoisted_270 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_271 = { class: "col-md-3" }
const _hoisted_272 = { class: "text-muted text-capitalize uppercase-text" }
const _hoisted_273 = { class: "mt-3" }
const _hoisted_274 = { key: 0 }
const _hoisted_275 = { class: "row" }
const _hoisted_276 = { class: "mt-3 border p-2" }
const _hoisted_277 = { key: 0 }
const _hoisted_278 = { key: 1 }
const _hoisted_279 = { key: 2 }
const _hoisted_280 = { class: "table-responsive mt-4 font-12" }
const _hoisted_281 = { class: "table mb-0 table-borderless" }
const _hoisted_282 = { class: "nowrap-text" }
const _hoisted_283 = { class: "table-active" }
const _hoisted_284 = { scope: "col" }
const _hoisted_285 = {
  key: 0,
  scope: "col"
}
const _hoisted_286 = {
  key: 1,
  scope: "col"
}
const _hoisted_287 = {
  key: 2,
  scope: "col"
}
const _hoisted_288 = {
  key: 3,
  scope: "col"
}
const _hoisted_289 = {
  key: 4,
  scope: "col"
}
const _hoisted_290 = {
  key: 5,
  scope: "col"
}
const _hoisted_291 = {
  key: 6,
  scope: "col"
}
const _hoisted_292 = {
  key: 7,
  scope: "col",
  class: "text-end"
}
const _hoisted_293 = { key: 0 }
const _hoisted_294 = { key: 1 }
const _hoisted_295 = { key: 0 }
const _hoisted_296 = { class: "desc-wrap" }
const _hoisted_297 = { key: 1 }
const _hoisted_298 = { key: 2 }
const _hoisted_299 = { key: 3 }
const _hoisted_300 = { key: 4 }
const _hoisted_301 = { key: 5 }
const _hoisted_302 = { key: 0 }
const _hoisted_303 = { key: 1 }
const _hoisted_304 = { key: 6 }
const _hoisted_305 = { key: 7 }
const _hoisted_306 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_307 = { class: "row justify-content-end" }
const _hoisted_308 = { class: "col-lg-4 col-md-6" }
const _hoisted_309 = { class: "total-box mb-4" }
const _hoisted_310 = { class: "table table-borderless table-nowrap align-middle mb-0 ms-auto" }
const _hoisted_311 = { class: "border-top border-top-dashed fs-15" }
const _hoisted_312 = { scope: "row" }
const _hoisted_313 = { class: "text-end" }
const _hoisted_314 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_315 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_316 = {
  key: 1,
  class: "tab-wrap bg-white rounded px-3 pb-3 border mt-3"
}
const _hoisted_317 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_318 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_319 = {
  class: "nav-link active",
  id: "Acknowledgement-tab",
  "data-toggle": "tab",
  "data-target": "#Acknowledgement",
  type: "button",
  role: "tab",
  "aria-controls": "Acknowledgement",
  "aria-selected": "true"
}
const _hoisted_320 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_321 = {
  class: "nav-link",
  id: "LegalStatement-tab",
  "data-toggle": "tab",
  "data-target": "#LegalStatement",
  type: "button",
  role: "tab",
  "aria-controls": "LegalStatement",
  "aria-selected": "false"
}
const _hoisted_322 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_323 = {
  class: "tab-pane fade show active",
  id: "Acknowledgement",
  role: "tabpanel",
  "aria-labelledby": "Acknowledgement-tab"
}
const _hoisted_324 = {
  class: "tab-pane fade",
  id: "LegalStatement",
  role: "tabpanel",
  "aria-labelledby": "LegalStatement-tab"
}
const _hoisted_325 = {
  key: 2,
  class: "alert alert-info mt-3"
}
const _hoisted_326 = { class: "mb-0" }
const _hoisted_327 = {
  key: 3,
  class: "mt-3 pl-3"
}
const _hoisted_328 = { class: "mb-0" }
const _hoisted_329 = /*#__PURE__*/_createVNode("strong", null, " Channel: ", -1)
const _hoisted_330 = {
  key: 4,
  class: "row"
}
const _hoisted_331 = { class: "col-md-4 mt-4" }
const _hoisted_332 = { class: "signature-wrap mt-2" }
const _hoisted_333 = { class: "modal-footer" }
const _hoisted_334 = {
  type: "button",
  class: "btn secondary-btn",
  "data-dismiss": "modal"
}
const _hoisted_335 = { class: "modal-wrap default-modal" }
const _hoisted_336 = {
  class: "modal fade",
  id: "addUnite",
  tabindex: -1,
  "aria-labelledby": "hidePojectLabel",
  "aria-hidden": "true"
}
const _hoisted_337 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_338 = { class: "modal-content" }
const _hoisted_339 = { class: "modal-header" }
const _hoisted_340 = {
  key: 0,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_341 = {
  key: 1,
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_342 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_343 = { class: "modal-body" }
const _hoisted_344 = { class: "form-group" }
const _hoisted_345 = { for: "" }
const _hoisted_346 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_347 = { class: "form-group" }
const _hoisted_348 = { for: "" }
const _hoisted_349 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_350 = { class: "modal-footer" }
const _hoisted_351 = { class: "modal-wrap default-modal" }
const _hoisted_352 = {
  class: "modal fade",
  id: "deleteItem",
  "aria-labelledby": "view-modalLabel",
  "aria-hidden": "true"
}
const _hoisted_353 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_354 = { class: "modal-content" }
const _hoisted_355 = { class: "modal-header" }
const _hoisted_356 = {
  class: "modal-title",
  id: "view-modalLabel"
}
const _hoisted_357 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_358 = { class: "modal-body" }
const _hoisted_359 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_360 = { class: "text-danger" }
const _hoisted_361 = { class: "modal-footer" }
const _hoisted_362 = { class: "modal-wrap default-modal" }
const _hoisted_363 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "updateUpload",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_364 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_365 = { class: "modal-content" }
const _hoisted_366 = { class: "modal-header" }
const _hoisted_367 = { class: "d-block" }
const _hoisted_368 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_369 = { class: "text-muted" }
const _hoisted_370 = { class: "modal-body" }
const _hoisted_371 = { class: "modal-content" }
const _hoisted_372 = { class: "modal-footer justify-content-start" }
const _hoisted_373 = /*#__PURE__*/_createVNode("i", { class: "fa fa-crop-alt" }, null, -1)
const _hoisted_374 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eraser" }, null, -1)
const _hoisted_375 = /*#__PURE__*/_createVNode("i", { class: "fa fa-redo" }, null, -1)
const _hoisted_376 = /*#__PURE__*/_createVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_377 = { class: "modal-wrap default-modal" }
const _hoisted_378 = {
  key: 0,
  class: "custom-modal-overlay"
}
const _hoisted_379 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_380 = { class: "modal-content" }
const _hoisted_381 = { class: "modal-header" }
const _hoisted_382 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "editCustomerModalLabel"
}, null, -1)
const _hoisted_383 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_384 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_385 = { class: "row mx-n2" }
const _hoisted_386 = { class: "col-xl-6 px-2" }
const _hoisted_387 = { class: "form-group" }
const _hoisted_388 = { class: "text-red" }
const _hoisted_389 = { class: "col-xl-6 px-2" }
const _hoisted_390 = { class: "form-group" }
const _hoisted_391 = { class: "text-red" }
const _hoisted_392 = { class: "col-xl-6 px-2" }
const _hoisted_393 = { class: "form-group" }
const _hoisted_394 = { class: "text-red" }
const _hoisted_395 = { class: "col-xl-6 px-2" }
const _hoisted_396 = { class: "form-group" }
const _hoisted_397 = { for: "" }
const _hoisted_398 = { class: "text-red" }
const _hoisted_399 = { class: "col-xl-6 px-2" }
const _hoisted_400 = { class: "form-group" }
const _hoisted_401 = { class: "notify-by-form-group" }
const _hoisted_402 = { class: "form-check form-check-inline" }
const _hoisted_403 = { class: "form-check-label" }
const _hoisted_404 = { class: "form-check form-check-inline" }
const _hoisted_405 = { class: "form-check-label" }
const _hoisted_406 = { class: "text-red" }
const _hoisted_407 = { class: "modal-footer" }
const _hoisted_408 = { class: "modal-wrap default-modal" }
const _hoisted_409 = {
  class: "modal fade",
  id: "addCompanyInfo",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_410 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_411 = { class: "modal-content" }
const _hoisted_412 = { class: "modal-header" }
const _hoisted_413 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_414 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_415 = { class: "modal-body" }
const _hoisted_416 = { class: "row" }
const _hoisted_417 = { class: "col-md-12" }
const _hoisted_418 = {
  key: 0,
  class: "form-group"
}
const _hoisted_419 = { for: "" }
const _hoisted_420 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_421 = { class: "form-group" }
const _hoisted_422 = { for: "" }
const _hoisted_423 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_424 = { class: "form-group" }
const _hoisted_425 = { for: "" }
const _hoisted_426 = { class: "form-group" }
const _hoisted_427 = { for: "" }
const _hoisted_428 = {
  key: 0,
  class: "signature-wrap"
}
const _hoisted_429 = { class: "custom-file" }
const _hoisted_430 = { class: "upload-btn-wrapper" }
const _hoisted_431 = {
  for: "formFileSm",
  class: "btn default-btn mr-2"
}
const _hoisted_432 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-up" }, null, -1)
const _hoisted_433 = { class: "form-group" }
const _hoisted_434 = { for: "" }
const _hoisted_435 = { class: "form-group" }
const _hoisted_436 = { for: "" }
const _hoisted_437 = { class: "modal-footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_CustomLoader = _resolveComponent("CustomLoader")
  const _component_CustomModal = _resolveComponent("CustomModal")
  const _component_CurrencyInput = _resolveComponent("CurrencyInput")
  const _component_VoiceToText = _resolveComponent("VoiceToText")
  const _component_Label = _resolveComponent("Label")
  const _component_AppEmailAndPhoneNumberValidate = _resolveComponent("AppEmailAndPhoneNumberValidate")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_CreateLineItemInJobEstimation = _resolveComponent("CreateLineItemInJobEstimation")
  const _component_VuePictureCropper = _resolveComponent("VuePictureCropper")
  const _component_AppPhoneNumberInput = _resolveComponent("AppPhoneNumberInput")
  const _component_Editor = _resolveComponent("Editor")
  const _component_ToDoChatChannelModel = _resolveComponent("ToDoChatChannelModel")
  const _component_SignaturePadModal = _resolveComponent("SignaturePadModal")
  const _component_SignatureUploadModal = _resolveComponent("SignatureUploadModal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              (_ctx.state.ui.isLoading.addNewSubItem)
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    href: "javascript:void(0)",
                    class: "btn default-btn outline d-inline-block",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewSubItem && _ctx.addNewSubItem(...args)))
                  }, [
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                  ]))
                : (_openBlock(), _createBlock("a", {
                    key: 1,
                    href: "javascript:void(0)",
                    class: "btn default-btn outline d-inline-block",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.gotoJobEstimation && _ctx.gotoJobEstimation(...args)))
                  }, [
                    _hoisted_6,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
                  ]))
            ])
          ])
        ])
      ]),
      _createVNode("div", null, [
        _createVNode(_component_ErrorList, {
          errors: _ctx.state.ui.errors.errorList.sendJobEstimation,
          hasError: _ctx.state.ui.errors.hasError
        }, null, 8, ["errors", "hasError"])
      ]),
      _createVNode(_component_CustomModal, {
        visible: _ctx.showLineItemModal,
        "onUpdate:visible": _cache[5] || (_cache[5] = val => { _ctx.showLineItemModal= val; })
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_7, [
            _createVNode("a", {
              class: "border-bottom text-success mb-2",
              href: "javascript:void(0)",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addNewSubItem(_ctx.currenylySelectedState.index)))
            }, "+ " + _toDisplayString(_ctx.$t('add')) + " " + _toDisplayString(_ctx.$t('new_item')), 1),
            (_ctx.state.ui.isLoading.getData)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode(_component_CustomLoader)
                ]))
              : _createCommentVNode("", true),
            (_ctx.currenylySelectedState?.value?.tableSelected)
              ? (_openBlock(), _createBlock("div", _hoisted_9, null, 512))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_10, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn btn-sm jobitem-btn",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closeSelected(_ctx.currenylySelectedState.index)))
              }, [
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('ok')), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["visible"]),
      (!_ctx.state.ui.isLoading.addNewSubItem)
        ? (_openBlock(), _createBlock("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("table", _hoisted_14, [
                _createVNode("thead", _hoisted_15, [
                  _createVNode("tr", null, [
                    _createVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('item')), 1),
                    _createVNode("th", _hoisted_17, [
                      _createVNode("div", _hoisted_18, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.fields.description = $event)),
                          id: "defaultCheck1"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.description]
                        ]),
                        _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('description')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.fields.quantity = $event)),
                          id: "defaultCheck2"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.quantity]
                        ]),
                        _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('qty')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_23, [
                      _createVNode("div", _hoisted_24, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.fields.unit = $event)),
                          id: "defaultCheck3"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.unit]
                        ]),
                        _createVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('unit')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_26, [
                      _createVNode("div", _hoisted_27, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.fields.cost = $event)),
                          id: "defaultCheck2"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.cost]
                        ]),
                        _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('cost')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_29, [
                      _createVNode("div", _hoisted_30, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.fields.subTotal = $event)),
                          id: "defaultCheck2"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.subTotal]
                        ]),
                        _createVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('sub_total')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_32, [
                      _createVNode("div", _hoisted_33, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.state.fields.markup = $event)),
                          id: "defaultCheck4"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.markup]
                        ]),
                        _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('markup')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_35, [
                      _createVNode("div", _hoisted_36, [
                        _createVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('set_allowance')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_38, [
                      _createVNode("div", _hoisted_39, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.state.fields.allowance = $event)),
                          id: "defaultCheck4"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.allowance]
                        ]),
                        _createVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('allowance')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_41, [
                      _createVNode("div", _hoisted_42, [
                        _withDirectives(_createVNode("input", {
                          class: "form-check-input mt-0 ml-0",
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.state.fields.total = $event)),
                          id: "defaultCheck5"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.state.fields.total]
                        ]),
                        _createVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('total')), 1)
                      ])
                    ]),
                    _createVNode("th", _hoisted_44, _toDisplayString(_ctx.$t('action')), 1)
                  ])
                ]),
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectItems, (selectedItem, selectedItemIndex) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: selectedItem.id
                    }, [
                      _createVNode("td", null, [
                        _createVNode("div", null, [
                          _createVNode("a", {
                            class: [
                                        'border',
                                        'rounded',
                                        'py-2',
                                        'px-3',
                                        { 'border-danger': selectedItem.nameError, 'd-block': selectedItem.isEditing, 'd-none': !selectedItem.isEditing }
                                    ],
                            type: "button",
                            "data-toggle": "dropdown",
                            "aria-expanded": "false",
                            onClick: () => {
                                            _ctx.currenylySelectedState = {
                                                index: selectedItemIndex,
                                                value: selectedItem
                                            }
                                            _ctx.onToggleChooseItem(selectedItemIndex)
                                        }
                          }, [
                            (selectedItem.parent_id)
                              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(selectedItem.name ? selectedItem.mainName + ':' + selectedItem.name :
                                            'ChooseItem'), 1)
                                ], 64))
                              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(selectedItem.name ? selectedItem.name : _ctx.$t('choose_item')), 1)
                                ], 64))
                          ], 10, ["onClick"]),
                          _withDirectives(_createVNode("span", null, _toDisplayString(selectedItem.name ? (selectedItem.mainName ? selectedItem.mainName + ':' +
                                            selectedItem.name : selectedItem.name) : '-'), 513), [
                            [_vShow, !selectedItem.isEditing]
                          ])
                        ])
                      ]),
                      _createVNode("td", null, [
                        (selectedItem.isEditing)
                          ? _withDirectives((_openBlock(), _createBlock("textarea", {
                              key: 0,
                              class: "form-control",
                              "onUpdate:modelValue": ($event: any) => (selectedItem.description = $event),
                              rows: 5
                            }, null, 8, ["onUpdate:modelValue"])), [
                              [_vModelText, selectedItem.description]
                            ])
                          : (_openBlock(), _createBlock("span", _hoisted_45, _toDisplayString(selectedItem?.description ?? '-'), 1))
                      ]),
                      _createVNode("td", null, [
                        (selectedItem.isEditing)
                          ? _withDirectives((_openBlock(), _createBlock("input", {
                              key: 0,
                              type: "number",
                              class: selectedItem.quantityError ? 'form-control error-field' : 'form-control',
                              "onUpdate:modelValue": ($event: any) => (selectedItem.quantity = $event),
                              onKeyup: ($event: any) => (_ctx.calculateTotal(selectedItem))
                            }, null, 42, ["onUpdate:modelValue", "onKeyup"])), [
                              [_vModelText, selectedItem.quantity]
                            ])
                          : (_openBlock(), _createBlock("span", _hoisted_46, _toDisplayString(selectedItem?.quantity ?? '-'), 1))
                      ]),
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_47, [
                          (selectedItem.isEditing)
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                class: selectedItem.unitError ? 'dropdown-toggle d-block border rounded py-2 px-3 error-field' : 'dropdown-toggle d-block border rounded py-2 px-3',
                                type: "button",
                                "data-toggle": "dropdown",
                                "aria-expanded": "false"
                              }, [
                                _createVNode("span", _hoisted_48, _toDisplayString(selectedItem.unit ?
                                            selectedItem.unit.name : 'Select Unit'), 1)
                              ], 2))
                            : (_openBlock(), _createBlock("span", _hoisted_49, _toDisplayString(selectedItem?.unit?.name ?? '-'), 1)),
                          _createVNode("div", _hoisted_50, [
                            _createVNode("a", {
                              class: "dropdown-item border-bottom text-success",
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.addNewUnit(selectedItem))
                            }, "+ " + _toDisplayString(_ctx.$t('add_new_unit')), 9, ["onClick"]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.unitLists, (unit, unitIndex) => {
                              return (_openBlock(), _createBlock("a", {
                                class: "dropdown-item with-actions",
                                href: "javascript:void(0)",
                                key: unitIndex
                              }, [
                                _createVNode("span", {
                                  class: "unit-title d-block",
                                  onClick: ($event: any) => (_ctx.changeUnit(selectedItemIndex, unit))
                                }, _toDisplayString(unit.name), 9, ["onClick"]),
                                _createVNode("span", _hoisted_51, [
                                  _createVNode("span", {
                                    class: "actions-text",
                                    onClick: ($event: any) => (_ctx.editUnit(unit))
                                  }, [
                                    _hoisted_52,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                                  ], 8, ["onClick"]),
                                  _createVNode("span", {
                                    class: "actions-text ml-2",
                                    onClick: ($event: any) => (_ctx.deleteUnit(selectedItem, unit))
                                  }, [
                                    _hoisted_53,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                  ], 8, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]),
                      _createVNode("td", null, [
                        (selectedItem.isEditing)
                          ? (_openBlock(), _createBlock(_component_CurrencyInput, {
                              key: 0,
                              class: selectedItem.costError ? 'hasError' : '',
                              modelValue: selectedItem.cost,
                              "onUpdate:modelValue": ($event: any) => (selectedItem.cost = $event),
                              onChange: ($event: any) => (_ctx.calculateTotal(selectedItem))
                            }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "onChange"]))
                          : (_openBlock(), _createBlock("span", _hoisted_54, _toDisplayString(selectedItem?.cost ?? '-'), 1))
                      ]),
                      _createVNode("td", null, _toDisplayString(_ctx.usdPriceFormate(selectedItem.subTotal ? selectedItem.subTotal : 0)), 1),
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_55, [
                          _createVNode("div", _hoisted_56, [
                            (selectedItem.isEditing)
                              ? (_openBlock(), _createBlock(_component_CurrencyInput, {
                                  key: 0,
                                  modelValue: selectedItem.markup,
                                  "onUpdate:modelValue": ($event: any) => (selectedItem.markup = $event),
                                  type: selectedItem.markup_type === 0 ? 'currency': 'percentage',
                                  onChange: ($event: any) => (_ctx.calculateTotal(selectedItem))
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "onChange"]))
                              : (_openBlock(), _createBlock("span", _hoisted_57, _toDisplayString(selectedItem?.markup ?? '-'), 1))
                          ]),
                          _createVNode("div", _hoisted_58, [
                            (selectedItem.isEditing)
                              ? (_openBlock(), _createBlock("a", _hoisted_59, [
                                  _createVNode("span", _hoisted_60, _toDisplayString(selectedItem.markup_type == 0 ?
                                                '$' : '%'), 1)
                                ]))
                              : (_openBlock(), _createBlock("span", _hoisted_61, _toDisplayString(selectedItem?.markup_type == 0 ?
                                            '$' : '%'), 1)),
                            _createVNode("div", _hoisted_62, [
                              _createVNode("a", {
                                class: "dropdown-item",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.changeMarkupType(selectedItemIndex, 0))
                              }, "$", 8, ["onClick"]),
                              _createVNode("a", {
                                class: "dropdown-item",
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.changeMarkupType(selectedItemIndex, 1))
                              }, "%", 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("td", null, [
                        _createVNode("input", {
                          disabled: !selectedItem.isEditing,
                          type: "checkbox",
                          checked: selectedItem.isAllowance,
                          onChange: ($event: any) => (_ctx.handleCheckboxChange(selectedItem, selectedItemIndex, $event))
                        }, null, 40, ["disabled", "checked", "onChange"])
                      ]),
                      _createVNode("td", null, [
                        (selectedItem.isEditing)
                          ? (_openBlock(), _createBlock(_component_CurrencyInput, {
                              key: 0,
                              disabled: !selectedItem.isAllowance,
                              modelValue: selectedItem.allowance,
                              "onUpdate:modelValue": ($event: any) => (selectedItem.allowance = $event)
                            }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"]))
                          : (_openBlock(), _createBlock("span", _hoisted_63, _toDisplayString(selectedItem?.allowance ?? 0), 1))
                      ]),
                      _createVNode("td", _hoisted_64, [
                        _createVNode("div", _hoisted_65, _toDisplayString(_ctx.usdPriceFormate(selectedItem.total ? selectedItem.total : 0)), 1)
                      ]),
                      _createVNode("td", _hoisted_66, [
                        (_ctx.state.selectItems.length != 1)
                          ? (_openBlock(), _createBlock("a", {
                              key: 0,
                              href: "javascript:void(0)",
                              class: "btn btn-info mr-1",
                              onClick: ($event: any) => (_ctx.cloneItem(selectedItemIndex, selectedItem)),
                              title: _ctx.$t('copy')
                            }, [
                              _hoisted_67
                            ], 8, ["onClick", "title"]))
                          : _createCommentVNode("", true),
                        (_ctx.state.selectItems.length != 1)
                          ? (_openBlock(), _createBlock("a", {
                              key: 1,
                              href: "javascript:void(0)",
                              class: "btn delete-btn",
                              onClick: ($event: any) => (_ctx.deleteItemShow(selectedItem)),
                              title: "remove"
                            }, [
                              _hoisted_68
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128)),
                  _createVNode("tr", _hoisted_69, [
                    _createVNode("td", _hoisted_70, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('markup')), 1)
                      ]),
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('total')), 1)
                      ])
                    ]),
                    _createVNode("td", _hoisted_71, [
                      _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(_ctx.totalMarkUP)), 1),
                      _createVNode("p", null, _toDisplayString(_ctx.usdPriceFormate(_ctx.total)), 1)
                    ])
                  ])
                ])
              ])
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectItems, (selectedItem, selectedItemIndex) => {
              return (_openBlock(), _createBlock("div", { key: selectedItemIndex }, [
                (selectedItemIndex == _ctx.state.selectItems.length - 1)
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      href: "javascript:void(0)",
                      class: "btn enable-btn mr-1 btn-sm my-2 d-inline-flex align-items-center",
                      onClick: ($event: any) => (_ctx.addMoreSubItems(selectedItem)),
                      title: _ctx.$t('add')
                    }, [
                      _hoisted_72,
                      _hoisted_73
                    ], 8, ["onClick", "title"]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _hoisted_74,
      (!_ctx.state.data.details.logo)
        ? (_openBlock(), _createBlock("div", _hoisted_75, [
            _createVNode("a", {
              "data-toggle": "modal",
              class: "btn default-btn d-inline-block mr-2",
              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.showCreateCompanyModel && _ctx.showCreateCompanyModel(...args)))
            }, _toDisplayString(_ctx.$t('add_company_information')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.data.details.acknowledgement &&
            _ctx.state.data.details.legal_statement
        )
        ? (_openBlock(), _createBlock("p", _hoisted_76, [
            _createVNode("strong", null, _toDisplayString(_ctx.$t('company_contract_preview')), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.state.data.details.acknowledgement &&
            _ctx.state.data.details.legal_statement
        )
        ? (_openBlock(), _createBlock("div", _hoisted_77, [
            _createVNode("p", null, [
              _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')), 1),
              _createVNode("a", {
                class: "btn default-btn btn-sm ms-2",
                title: "Edit",
                href: "javascript:void(0)",
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.editCompany && _ctx.editCompany(...args)))
              }, [
                _hoisted_78,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
              ])
            ]),
            (_ctx.state.data.details.logo)
              ? (_openBlock(), _createBlock("div", _hoisted_79, [
                  (_ctx.state.data.details.logo && _ctx.state.data.details.logo.file)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        class: "rounded",
                        src: _ctx.state.data.details.logo.file
                    ? _ctx.state.data.details.logo.file
                    : _ctx.state.data.details.logo
                    ,
                        alt: ""
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock("img", {
                        key: 1,
                        class: "rounded",
                        src: _ctx.state.data.details.logo,
                        alt: ""
                      }, null, 8, ["src"]))
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_80, [
              _createVNode("ul", _hoisted_81, [
                _createVNode("li", _hoisted_82, [
                  _createVNode("button", _hoisted_83, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                ]),
                _createVNode("li", _hoisted_84, [
                  _createVNode("button", _hoisted_85, _toDisplayString(_ctx.$t('legal_statement')), 1)
                ])
              ]),
              _createVNode("div", _hoisted_86, [
                _createVNode("div", _hoisted_87, [
                  _createVNode("div", {
                    innerHTML: _ctx.state.data.details.acknowledgement
                  }, null, 8, ["innerHTML"])
                ]),
                _createVNode("div", _hoisted_88, [
                  _createVNode("div", {
                    innerHTML: _ctx.state.data.details.legal_statement
                  }, null, 8, ["innerHTML"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_89, [
        _createVNode("ul", null, [
          _createVNode("li", null, [
            (_ctx.state.data.cropSignature || _ctx.state.data.sendarSignature)
              ? (_openBlock(), _createBlock("div", _hoisted_90, [
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_91, [
                      _createVNode("img", {
                        src: _ctx.state.data.cropSignature ? _ctx.state.data.cropSignature : _ctx.state.data.sendarSignature,
                        alt: ""
                      }, null, 8, ["src"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_92, [
              _createVNode("div", _hoisted_93, [
                _createVNode("ul", null, [
                  _createVNode("li", null, [
                    _createVNode("div", _hoisted_94, [
                      _createVNode("button", _hoisted_95, [
                        _hoisted_96,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('upload_signature')), 1)
                      ]),
                      _createVNode("input", {
                        ref: "signatureInput",
                        type: "file",
                        accept: "image/png, image/jpeg",
                        id: "profileUpdate",
                        onChange: _cache[16] || (_cache[16] = ($event: any) => (_ctx.uploadSignatureFile($event)))
                      }, null, 544)
                    ])
                  ]),
                  _createVNode("li", null, [
                    _createVNode("button", {
                      class: "btn default-btn",
                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.showSignaturePad && _ctx.showSignaturePad(...args)))
                    }, [
                      _hoisted_97,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('draw_signature')), 1)
                    ])
                  ]),
                  (_ctx.state.data.haveProfileSign)
                    ? (_openBlock(), _createBlock("li", _hoisted_98, [
                        _createVNode("div", _hoisted_99, [
                          _createVNode("button", {
                            for: "formFileSm",
                            class: "btn default-btn mr-2",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.userSignature('use')))
                          }, [
                            _hoisted_100,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('use_profile_signature')), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("li", null, [
                    _createVNode("button", {
                      class: "btn red-btn",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.clearSignature()))
                    }, _toDisplayString(_ctx.$t('clear')), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_101, [
        _createVNode("div", _hoisted_102, [
          _createVNode("div", _hoisted_103, [
            _createVNode("label", _hoisted_104, _toDisplayString(_ctx.$t('note')), 1),
            _createVNode(_component_VoiceToText, {
              onStartRecording: _cache[20] || (_cache[20] = ($event: any) => (_ctx.startRecording($event)))
            })
          ]),
          _withDirectives(_createVNode("textarea", {
            class: "form-control h-auto",
            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.state.data.note = $event)),
            rows: 10
          }, null, 512), [
            [_vModelText, _ctx.state.data.note]
          ])
        ])
      ]),
      _createVNode("div", _hoisted_105, [
        _createVNode("div", _hoisted_106, [
          _createVNode("h2", _hoisted_107, [
            _createVNode("button", {
              class: ["btn btn-link btn-block rounded text-left collapsed border", _ctx.state.showChooseMembers ? 'accordion-btn' : 'accordion-btn collapsed'],
              "data-toggle": "collapse",
              "data-target": "#chooseMembersCollapse",
              "aria-expanded": _ctx.state.showChooseMembers,
              "aria-controls": "chooseMembersCollapse",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.state.showChooseMembers = !_ctx.state.showChooseMembers))
            }, [
              _hoisted_108
            ], 10, ["aria-expanded"])
          ])
        ]),
        _createVNode("div", _hoisted_109, [
          _createVNode("div", _hoisted_110, [
            _createVNode("ul", _hoisted_111, [
              _createVNode("li", _hoisted_112, [
                _createVNode("button", {
                  class: ["nav-link", { active: _ctx.state.activeTab === 'projectstb' }],
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.switchTab('projectstb')))
                }, _toDisplayString(_ctx.projectName) + " Members ", 3)
              ]),
              _createVNode("li", _hoisted_113, [
                _createVNode("button", {
                  class: ["nav-link", { active: _ctx.state.activeTab === 'mycustomerstb' }],
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.switchTab('mycustomerstb')))
                }, " All My Customers ", 2)
              ]),
              _createVNode("li", _hoisted_114, [
                _createVNode("button", {
                  class: ["nav-link", { active: _ctx.state.activeTab === 'customerstb' }],
                  onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.switchTab('customerstb')))
                }, " Add Customer ", 2)
              ])
            ]),
            _createVNode("div", _hoisted_115, [
              _withDirectives(_createVNode("div", null, [
                _createVNode("div", _hoisted_116, [
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _createVNode(_component_Label, null, {
                        default: _withId(() => [
                          _hoisted_117
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("li", null, [
                      _withDirectives(_createVNode("select", {
                        name: "",
                        class: "custom-select custom-select-sm",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.state.data.selectedFilterProjectTab = $event)),
                        onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.handleFilterChange && _ctx.handleFilterChange(...args)))
                      }, [
                        _hoisted_118,
                        _hoisted_119
                      ], 544), [
                        [_vModelSelect, _ctx.state.data.selectedFilterProjectTab]
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_120, [
                  (!_ctx.state.ui.isHideChannelPart)
                    ? (_openBlock(), _createBlock("div", _hoisted_121, [
                        _createVNode("div", _hoisted_122, [
                          _createVNode("div", _hoisted_123, [
                            _createVNode("div", _hoisted_124, [
                              _hoisted_125,
                              _createVNode("div", _hoisted_126, [
                                _createVNode("div", _hoisted_127, [
                                  _createVNode("div", _hoisted_128, [
                                    _createVNode("a", {
                                      href: "javascript:void(0)",
                                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.customerChannelList(_ctx.state.ui.searchQuery.customerChannel)))
                                    }, [
                                      _hoisted_129
                                    ])
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.debouncedCustomerChannel = $event)),
                                    class: "form-control bg-light",
                                    placeholder: "Press enter to search",
                                    onInput: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.onChannelSearchInput && _ctx.onChannelSearchInput(...args))),
                                    onKeyup: _cache[31] || (_cache[31] = _withKeys(($event: any) => (_ctx.customerChannelList(_ctx.state.ui.searchQuery.customerChannel)), ["enter"]))
                                  }, null, 544), [
                                    [_vModelText, _ctx.debouncedCustomerChannel]
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", {
                            class: "vertical-nav-wrap channel-list-box custom-scroll",
                            onScroll: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.handleChannelScroll && _ctx.handleChannelScroll(...args)))
                          }, [
                            _createVNode("ul", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.customerChannels, (channel) => {
                                return (_openBlock(), _createBlock("li", {
                                  key: channel.uuid,
                                  class: { active: _ctx.state.data.selectedChannelUuid === channel.uuid }
                                }, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.selectCustomerChannel(channel.uuid))
                                  }, _toDisplayString(channel.name), 9, ["onClick"])
                                ], 2))
                              }), 128)),
                              (_ctx.state.data.customerChannels.length === 0)
                                ? (_openBlock(), _createBlock("li", _hoisted_130, [
                                    _hoisted_131
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.state.ui.isLoading.customerChannelList)
                              ? (_openBlock(), _createBlock("div", _hoisted_132, [
                                  _hoisted_133,
                                  _hoisted_134
                                ]))
                              : _createCommentVNode("", true)
                          ], 32)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_135, [
                    _createVNode("div", _hoisted_136, [
                      _createVNode("div", _hoisted_137, [
                        _createVNode("div", _hoisted_138, [
                          _hoisted_139,
                          _createVNode("div", _hoisted_140, [
                            _createVNode("div", _hoisted_141, [
                              _createVNode("div", _hoisted_142, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.selectCustomerChannel(_ctx.state.data.selectedChannelUuid, _ctx.state.ui.searchQuery.channelMembers)))
                                }, [
                                  _hoisted_143
                                ])
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.debouncedChannelMembers = $event)),
                                class: "form-control bg-light",
                                placeholder: "Press enter to search",
                                onInput: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.onChannelMemberSearchInput && _ctx.onChannelMemberSearchInput(...args))),
                                onKeyup: _cache[36] || (_cache[36] = _withKeys(($event: any) => (_ctx.selectCustomerChannel(_ctx.state.data.selectedChannelUuid, _ctx.state.ui.searchQuery.channelMembers)), ["enter"]))
                              }, null, 544), [
                                [_vModelText, _ctx.debouncedChannelMembers]
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", {
                        class: "px-2 border-top pt-3 member-list-box custom-scroll",
                        onScroll: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.handleChannelMemberScroll && _ctx.handleChannelMemberScroll(...args)))
                      }, [
                        _createVNode("div", null, [
                          (_ctx.channelMembers && _ctx.channelMembers.length)
                            ? (_openBlock(), _createBlock("div", _hoisted_144, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.channelMembers, (member) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "custom-control custom-checkbox",
                                    key: member.user_id
                                  }, [
                                    _createVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: 'member-' + member.user_id,
                                      value: member.user_id,
                                      checked: _ctx.state.data.selectedMemberIds.includes(member.user_id),
                                      onChange: ($event: any) => (_ctx.toggleMemberSelection(member.user_id, $event))
                                    }, null, 40, ["id", "value", "checked", "onChange"]),
                                    _createVNode("label", {
                                      class: "custom-control-label",
                                      for: 'member-' + member.user_id
                                    }, _toDisplayString(member.user_first_name) + " " + _toDisplayString(member.user_last_name) + " (" + _toDisplayString(member.user_email) + ") ", 9, ["for"])
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_145, " No members found for this channel. "))
                        ]),
                        (_ctx.state.ui.isLoading.customerChannelMemberList)
                          ? (_openBlock(), _createBlock("div", _hoisted_146, " Loading members... "))
                          : _createCommentVNode("", true)
                      ], 32)
                    ])
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.state.activeTab === 'projectstb']
              ]),
              _withDirectives(_createVNode("div", null, [
                _createVNode("div", _hoisted_147, [
                  _createVNode("ul", null, [
                    _createVNode("li", null, [
                      _createVNode(_component_Label, null, {
                        default: _withId(() => [
                          _hoisted_148
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("li", null, [
                      _withDirectives(_createVNode("select", {
                        name: "",
                        class: "custom-select custom-select-sm",
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.state.data.selectedFilterCustomerTab = $event)),
                        onChange: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.handleFilterChangeAll && _ctx.handleFilterChangeAll(...args)))
                      }, [
                        _hoisted_149,
                        _hoisted_150
                      ], 544), [
                        [_vModelSelect, _ctx.state.data.selectedFilterCustomerTab]
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_151, [
                  (!_ctx.state.ui.isHideChannelPart)
                    ? (_openBlock(), _createBlock("div", _hoisted_152, [
                        _createVNode("div", _hoisted_153, [
                          _createVNode("div", _hoisted_154, [
                            _createVNode("div", _hoisted_155, [
                              _hoisted_156,
                              _createVNode("div", _hoisted_157, [
                                _createVNode("div", _hoisted_158, [
                                  _createVNode("div", _hoisted_159, [
                                    _createVNode("a", {
                                      href: "javascript:void(0)",
                                      onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.customerProjectList(_ctx.state.ui.searchQuery.projects)))
                                    }, [
                                      _hoisted_160
                                    ])
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.debouncedProjects = $event)),
                                    class: "form-control bg-light",
                                    placeholder: "Press enter to search",
                                    onInput: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.onProjectSearchInput && _ctx.onProjectSearchInput(...args))),
                                    onKeyup: _cache[43] || (_cache[43] = _withKeys(($event: any) => (_ctx.customerProjectList(_ctx.state.ui.searchQuery.projects)), ["enter"]))
                                  }, null, 544), [
                                    [_vModelText, _ctx.debouncedProjects]
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", {
                            class: "vertical-nav-wrap channel-list-box custom-scroll",
                            onScroll: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.handleProjectScroll && _ctx.handleProjectScroll(...args)))
                          }, [
                            _createVNode("ul", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.customerProjects, (project) => {
                                return (_openBlock(), _createBlock("li", {
                                  key: project.uuid,
                                  class: { active: _ctx.state.data.selectedProjectUuid === project.uuid }
                                }, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.projectChannelList(project.uuid))
                                  }, _toDisplayString(project.name), 9, ["onClick"])
                                ], 2))
                              }), 128)),
                              (_ctx.state.data.customerProjects.length === 0)
                                ? (_openBlock(), _createBlock("li", _hoisted_161, [
                                    _hoisted_162
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.state.ui.isLoading.projectList)
                              ? (_openBlock(), _createBlock("div", _hoisted_163, [
                                  _hoisted_164,
                                  _hoisted_165
                                ]))
                              : _createCommentVNode("", true)
                          ], 32)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.ui.isHideChannelPart)
                    ? (_openBlock(), _createBlock("div", _hoisted_166, [
                        _createVNode("div", _hoisted_167, [
                          _createVNode("div", _hoisted_168, [
                            _createVNode("div", _hoisted_169, [
                              _hoisted_170,
                              _createVNode("div", _hoisted_171, [
                                _createVNode("div", _hoisted_172, [
                                  _createVNode("div", _hoisted_173, [
                                    _createVNode("a", {
                                      href: "javascript:void(0)",
                                      onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.projectChannelList(_ctx.state.data.selectedProjectUuid, _ctx.state.ui.searchQuery.customerChannel)))
                                    }, [
                                      _hoisted_174
                                    ])
                                  ]),
                                  _withDirectives(_createVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => (_ctx.state.ui.searchQuery.customerChannel = $event)),
                                    class: "form-control bg-light",
                                    placeholder: "Press enter to search",
                                    onInput: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.onChannelSearchInput && _ctx.onChannelSearchInput(...args))),
                                    onKeyup: _cache[48] || (_cache[48] = _withKeys(($event: any) => (_ctx.projectChannelList(_ctx.state.data.selectedProjectUuid, _ctx.state.ui.searchQuery.customerChannel)), ["enter"]))
                                  }, null, 544), [
                                    [_vModelText, _ctx.state.ui.searchQuery.customerChannel]
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _createVNode("div", {
                            class: "vertical-nav-wrap channel-list-box custom-scroll",
                            onScroll: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.handleProjectChannelScroll && _ctx.handleProjectChannelScroll(...args)))
                          }, [
                            _createVNode("ul", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectChannels, (channel) => {
                                return (_openBlock(), _createBlock("li", {
                                  key: channel.uuid,
                                  class: { active: _ctx.state.data.selectedChannelUuid === channel.uuid }
                                }, [
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.selectCustomerChannel(channel.uuid))
                                  }, _toDisplayString(channel.name), 9, ["onClick"])
                                ], 2))
                              }), 128)),
                              (_ctx.state.data.projectChannels.length === 0)
                                ? (_openBlock(), _createBlock("li", _hoisted_175, [
                                    _hoisted_176
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (_ctx.state.ui.isLoading.projectChannelList)
                              ? (_openBlock(), _createBlock("div", _hoisted_177, [
                                  _hoisted_178,
                                  _hoisted_179
                                ]))
                              : _createCommentVNode("", true)
                          ], 32)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_180, [
                    _createVNode("div", _hoisted_181, [
                      _createVNode("div", _hoisted_182, [
                        _createVNode("div", _hoisted_183, [
                          _hoisted_184,
                          _createVNode("div", _hoisted_185, [
                            _createVNode("div", _hoisted_186, [
                              _createVNode("div", _hoisted_187, [
                                _createVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.debouncedMemberSearch && _ctx.debouncedMemberSearch(...args)))
                                }, [
                                  _hoisted_188
                                ])
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_ctx.debouncedMemberSearch = $event)),
                                class: "form-control bg-light",
                                placeholder: "Press enter to search",
                                onInput: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.onChannelMemberSearchInput && _ctx.onChannelMemberSearchInput(...args))),
                                onKeyup: _cache[53] || (_cache[53] = _withKeys(
//@ts-ignore
(...args) => (_ctx.debouncedMemberSearch && _ctx.debouncedMemberSearch(...args)), ["enter"]))
                              }, null, 544), [
                                [_vModelText, _ctx.debouncedMemberSearch]
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", {
                        class: "px-2 border-top pt-3 member-list-box custom-scroll",
                        onScroll: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_ctx.onDynamicMemberScroll && _ctx.onDynamicMemberScroll(...args)))
                      }, [
                        _createVNode("div", null, [
                          (_ctx.channelMembers && _ctx.channelMembers.length)
                            ? (_openBlock(), _createBlock("div", _hoisted_189, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.channelMembers, (member) => {
                                  return (_openBlock(), _createBlock("div", {
                                    class: "custom-control custom-checkbox",
                                    key: member.user_id
                                  }, [
                                    _createVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: 'member-' + member.user_id,
                                      value: member.user_id,
                                      checked: _ctx.state.data.selectedMemberIds.includes(member.user_id),
                                      onChange: ($event: any) => (_ctx.toggleMemberSelection(member.user_id, $event))
                                    }, null, 40, ["id", "value", "checked", "onChange"]),
                                    _createVNode("label", {
                                      class: "custom-control-label",
                                      for: 'member-' + member.user_id
                                    }, _toDisplayString(member.user_first_name) + " " + _toDisplayString(member.user_last_name) + " (" + _toDisplayString(member.user_email || member.user_mobile_number) + ") ", 9, ["for"])
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createBlock("div", _hoisted_190, " No members found for this channel. "))
                        ]),
                        (_ctx.state.ui.isLoading.customerChannelMemberList)
                          ? (_openBlock(), _createBlock("div", _hoisted_191, " Loading members... "))
                          : _createCommentVNode("", true)
                      ], 32)
                    ])
                  ])
                ])
              ], 512), [
                [_vShow, _ctx.state.activeTab === 'mycustomerstb']
              ]),
              _withDirectives(_createVNode("div", null, [
                _createVNode("div", _hoisted_192, [
                  _createVNode("div", _hoisted_193, [
                    _createVNode("div", _hoisted_194, [
                      _createVNode("form", {
                        onSubmit: _cache[58] || (_cache[58] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addCustomer && _ctx.addCustomer(...args)), ["prevent"]))
                      }, [
                        _createVNode("div", _hoisted_195, [
                          _hoisted_196,
                          _createVNode("div", _hoisted_197, [
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => (_ctx.state.form.firstName = $event)),
                              type: "text",
                              class: "form-control",
                              id: "firstName"
                            }, null, 512), [
                              [_vModelText, _ctx.state.form.firstName]
                            ]),
                            (_ctx.state.errors.firstName)
                              ? (_openBlock(), _createBlock("p", _hoisted_198, _toDisplayString(_ctx.state.errors.firstName), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode("div", _hoisted_199, [
                          _hoisted_200,
                          _createVNode("div", _hoisted_201, [
                            _withDirectives(_createVNode("input", {
                              "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => (_ctx.state.form.lastName = $event)),
                              type: "text",
                              class: "form-control",
                              id: "lastName"
                            }, null, 512), [
                              [_vModelText, _ctx.state.form.lastName]
                            ]),
                            (_ctx.state.errors.lastName)
                              ? (_openBlock(), _createBlock("p", _hoisted_202, _toDisplayString(_ctx.state.errors.lastName), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createVNode("div", _hoisted_203, [
                          _hoisted_204,
                          _createVNode("div", _hoisted_205, [
                            _createVNode(_component_AppEmailAndPhoneNumberValidate, {
                              clear: _ctx.clearInputValue,
                              onUpdateInput: _cache[57] || (_cache[57] = val => _ctx.state.form.contact = val)
                            }, null, 8, ["clear"]),
                            (_ctx.state.errors.contact)
                              ? (_openBlock(), _createBlock("p", _hoisted_206, _toDisplayString(_ctx.state.errors.contact), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _hoisted_207
                      ], 32)
                    ])
                  ]),
                  (_ctx.state.data.formAddedMembers.some((m) => m.isFormAdded))
                    ? (_openBlock(), _createBlock("div", _hoisted_208, [
                        _createVNode("div", _hoisted_209, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.formAddedMembers.filter((c) => c.isFormAdded), (customer) => {
                            return (_openBlock(), _createBlock("div", {
                              key: customer.user_id,
                              class: "d-flex align-items-center mb-2"
                            }, [
                              _createVNode("div", _hoisted_210, [
                                _createVNode("input", {
                                  type: "checkbox",
                                  checked: _ctx.state.data.selectedMemberIds.includes(customer.user_id),
                                  onChange: ($event: any) => (_ctx.toggleMemberSelection(customer.user_id, $event)),
                                  class: "mr-2"
                                }, null, 40, ["checked", "onChange"]),
                                _createVNode("label", _hoisted_211, [
                                  (customer.user_first_name || customer.user_last_name)
                                    ? (_openBlock(), _createBlock("span", _hoisted_212, _toDisplayString(customer.user_first_name) + " " + _toDisplayString(customer.user_last_name) + " (" + _toDisplayString(customer.user_email || customer.user_mobile_number) + ") ", 1))
                                    : (customer.user_email)
                                      ? (_openBlock(), _createBlock("span", _hoisted_213, _toDisplayString(customer.user_email), 1))
                                      : (customer.user_mobile_number)
                                        ? (_openBlock(), _createBlock("span", _hoisted_214, _toDisplayString(customer.user_mobile_number), 1))
                                        : (_openBlock(), _createBlock("span", _hoisted_215, " Unknown User "))
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 512), [
                [_vShow, _ctx.state.activeTab === 'customerstb']
              ])
            ])
          ])
        ])
      ]),
      (_ctx.selectedMembers.length)
        ? (_openBlock(), _createBlock("div", _hoisted_216, [
            _hoisted_217,
            _createVNode("div", _hoisted_218, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedMembers, (member, memberIndex) => {
                return (_openBlock(), _createBlock("div", {
                  class: "col-md-4 col-sm-6 mb-2 px-2",
                  key: memberIndex
                }, [
                  _createVNode("div", _hoisted_219, [
                    _createVNode("p", null, [
                      _hoisted_220,
                      _createTextVNode(" " + _toDisplayString(member.user_first_name) + " " + _toDisplayString(member.user_last_name), 1)
                    ]),
                    _createVNode("div", _hoisted_221, [
                      (_ctx.isEmail(member.user_email))
                        ? (_openBlock(), _createBlock("div", _hoisted_222, [
                            _createVNode("p", null, [
                              _hoisted_223,
                              _createTextVNode(" " + _toDisplayString(member.user_email), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (member.user_mobile_number)
                        ? (_openBlock(), _createBlock("div", _hoisted_224, [
                            _createVNode("p", null, [
                              _hoisted_225,
                              _createTextVNode(" " + _toDisplayString(member.user_mobile_number), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("div", _hoisted_226, [
                      _createVNode("div", _hoisted_227, [
                        _hoisted_228,
                        (member.mailNotification)
                          ? (_openBlock(), _createBlock("p", _hoisted_229, [
                              _hoisted_230,
                              _hoisted_231
                            ]))
                          : _createCommentVNode("", true),
                        (member.smsNotification)
                          ? (_openBlock(), _createBlock("p", _hoisted_232, [
                              _hoisted_233,
                              _hoisted_234
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("div", _hoisted_235, [
                        _createVNode("button", {
                          class: "btn default-btn btn-sm mr-2",
                          title: "Edit",
                          onClick: ($event: any) => (_ctx.editSelectCustomer(member))
                        }, [
                          _hoisted_236,
                          _hoisted_237
                        ], 8, ["onClick"]),
                        _createVNode("a", {
                          class: "btn btn-sm red-btn",
                          title: "Delete",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.removeSelectedMember(member.user_id))
                        }, [
                          _hoisted_238,
                          _hoisted_239
                        ], 8, ["onClick"])
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_240, [
        _createVNode("div", _hoisted_241, [
          _createVNode("div", _hoisted_242, [
            _createVNode("div", _hoisted_243, [
              _createVNode("button", {
                class: "btn default-btn mr-1",
                onClick: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_ctx.redirectToChat && _ctx.redirectToChat(...args)))
              }, [
                _hoisted_244,
                _createTextVNode(" " + _toDisplayString(_ctx.state.selectedChannel && (_ctx.state.selectedChannel.name || _ctx.state.selectedChannel.id) ?
                            "Change Channel" : "Choose Channel to Discuss"), 1)
              ]),
              (_ctx.state.selectedChannel)
                ? (_openBlock(), _createBlock("span", _hoisted_245, _toDisplayString(_ctx.state.selectedChannel.name), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_246, [
          _createVNode("div", _hoisted_247, [
            _withDirectives(_createVNode("input", {
              class: "form-check-input mt-0 ml-0",
              type: "checkbox",
              "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => (_ctx.state.approveByAll = $event)),
              id: "defaultCheck6"
            }, null, 512), [
              [_vModelCheckbox, _ctx.state.approveByAll]
            ]),
            _createVNode("label", _hoisted_248, _toDisplayString(_ctx.$t('approve_by_all_members')), 1)
          ])
        ])
      ]),
      (_ctx.state.ui.errors.hasError)
        ? (_openBlock(), _createBlock("p", _hoisted_249, _toDisplayString(_ctx.$t('input_field_required')) + ".", 1))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_250, [
        _createVNode("button", {
          type: "submit",
          class: "btn default-btn mr-2",
          onClick: _cache[61] || (_cache[61] = 
//@ts-ignore
(...args) => (_ctx.sendJobEstimation && _ctx.sendJobEstimation(...args))),
          disabled: _ctx.state.ui.isPostLoading.createJobEstimation
        }, _toDisplayString(_ctx.state.ui.isPostLoading.createJobEstimation ?
                _ctx.$t('loading1') : _ctx.$t('update')), 9, ["disabled"]),
        _createVNode("a", _hoisted_251, [
          _hoisted_252,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('preview')), 1)
        ])
      ]),
      _createVNode("div", _hoisted_253, [
        _createVNode("div", _hoisted_254, [
          _createVNode("div", _hoisted_255, [
            _createVNode("div", _hoisted_256, [
              _hoisted_257,
              _createVNode("div", _hoisted_258, [
                _createVNode("div", _hoisted_259, [
                  _createVNode("div", _hoisted_260, [
                    _createVNode("div", _hoisted_261, [
                      _createVNode("div", _hoisted_262, [
                        _createVNode("img", {
                          src: _ctx.state.data.companyInfo.logo.file
                                                ? _ctx.state.data.companyInfo.logo.file
                                                : _ctx.state.data.companyInfo.logo
                                                ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("div", _hoisted_263, [
                        _createVNode("p", null, [
                          _createVNode("strong", _hoisted_264, _toDisplayString(_ctx.$t('address')), 1)
                        ]),
                        _createVNode("p", null, _toDisplayString(_ctx.state.data.companyInfo.company_address), 1)
                      ])
                    ])
                  ]),
                  _hoisted_265,
                  _createVNode("div", _hoisted_266, [
                    _createVNode("div", _hoisted_267, [
                      _createVNode("p", null, [
                        _createVNode("strong", _hoisted_268, _toDisplayString(_ctx.$t('estimation_title')), 1)
                      ]),
                      _createVNode("p", null, _toDisplayString(_ctx.state.data.details.title), 1)
                    ]),
                    _createVNode("div", _hoisted_269, [
                      _createVNode("p", null, [
                        _createVNode("strong", _hoisted_270, _toDisplayString(_ctx.$t('estimation_no')), 1)
                      ]),
                      _createVNode("p", null, "# " + _toDisplayString(_ctx.state.data.details.no), 1)
                    ]),
                    _createVNode("div", _hoisted_271, [
                      _createVNode("p", null, [
                        _createVNode("strong", _hoisted_272, _toDisplayString(_ctx.$t('date')), 1)
                      ]),
                      _createVNode("p", null, _toDisplayString(_ctx.state.data.createDate), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_273, [
                    (_ctx.state.data && _ctx.state.data.selectedMembers && _ctx.state.data.selectedMembers.length)
                      ? (_openBlock(), _createBlock("p", _hoisted_274, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('customer_details')) + ":", 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_275, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.selectedMembers, (customer, customerIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "col-md-4",
                          key: customerIndex
                        }, [
                          _createVNode("div", _hoisted_276, [
                            (customer.user_first_name || customer.user_last_name)
                              ? (_openBlock(), _createBlock("p", _hoisted_277, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('name')) + ": ", 1),
                                  _createTextVNode(_toDisplayString(customer.user_first_name) + " " + _toDisplayString(customer.user_last_name), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (customer.user_email)
                              ? (_openBlock(), _createBlock("p", _hoisted_278, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('email')) + ":", 1),
                                  _createTextVNode(" " + _toDisplayString(customer.user_email), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (customer.user_mobile_number)
                              ? (_openBlock(), _createBlock("p", _hoisted_279, [
                                  _createVNode("strong", null, _toDisplayString(_ctx.$t('phone_no')) + ":", 1),
                                  _createTextVNode(" " + _toDisplayString(customer.user_mobile_number), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createVNode("div", _hoisted_280, [
                    _createVNode("table", _hoisted_281, [
                      _createVNode("thead", _hoisted_282, [
                        _createVNode("tr", _hoisted_283, [
                          _createVNode("th", _hoisted_284, _toDisplayString(_ctx.$t('item')), 1),
                          (_ctx.state.fields.description)
                            ? (_openBlock(), _createBlock("th", _hoisted_285, _toDisplayString(_ctx.$t('description')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.quantity)
                            ? (_openBlock(), _createBlock("th", _hoisted_286, _toDisplayString(_ctx.$t('qty')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.unit)
                            ? (_openBlock(), _createBlock("th", _hoisted_287, _toDisplayString(_ctx.$t('unit')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.cost)
                            ? (_openBlock(), _createBlock("th", _hoisted_288, _toDisplayString(_ctx.$t('cost')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.subTotal)
                            ? (_openBlock(), _createBlock("th", _hoisted_289, _toDisplayString(_ctx.$t('sub_total')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.markup)
                            ? (_openBlock(), _createBlock("th", _hoisted_290, _toDisplayString(_ctx.$t('markup')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.allowance)
                            ? (_openBlock(), _createBlock("th", _hoisted_291, _toDisplayString(_ctx.$t('allowance')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.state.fields.total)
                            ? (_openBlock(), _createBlock("th", _hoisted_292, _toDisplayString(_ctx.$t('total')), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createVNode("tbody", null, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectItems, (item, itemIndex) => {
                          return (_openBlock(), _createBlock("tr", { key: itemIndex }, [
                            _createVNode("td", null, [
                              (item.parent_id)
                                ? (_openBlock(), _createBlock("p", _hoisted_293, _toDisplayString(item.main_item_name) + ": " + _toDisplayString(item.name), 1))
                                : (_openBlock(), _createBlock("p", _hoisted_294, _toDisplayString(item.name), 1))
                            ]),
                            (_ctx.state.fields.description)
                              ? (_openBlock(), _createBlock("td", _hoisted_295, [
                                  _createVNode("div", _hoisted_296, [
                                    _createVNode("p", null, _toDisplayString(item.description), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.quantity)
                              ? (_openBlock(), _createBlock("td", _hoisted_297, [
                                  _createVNode("p", null, _toDisplayString(item.quantity), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.unit)
                              ? (_openBlock(), _createBlock("td", _hoisted_298, [
                                  _createVNode("p", null, _toDisplayString(item.unit ? item.unit.name : ''), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.cost)
                              ? (_openBlock(), _createBlock("td", _hoisted_299, [
                                  _createVNode("p", null, _toDisplayString(item.cost), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.subTotal)
                              ? (_openBlock(), _createBlock("td", _hoisted_300, [
                                  _createVNode("p", null, _toDisplayString(item.subTotal), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.markup)
                              ? (_openBlock(), _createBlock("td", _hoisted_301, [
                                  (item.markup_type == 1)
                                    ? (_openBlock(), _createBlock("p", _hoisted_302, _toDisplayString(item.markup) + " %", 1))
                                    : (_openBlock(), _createBlock("p", _hoisted_303, _toDisplayString(item.markup), 1))
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.allowance)
                              ? (_openBlock(), _createBlock("td", _hoisted_304, [
                                  _createVNode("p", null, _toDisplayString(item.allowance), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.fields.total)
                              ? (_openBlock(), _createBlock("td", _hoisted_305, [
                                  _createVNode("p", null, _toDisplayString(item.total), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _hoisted_306,
                  _createVNode("div", _hoisted_307, [
                    _createVNode("div", _hoisted_308, [
                      _createVNode("div", _hoisted_309, [
                        _createVNode("table", _hoisted_310, [
                          _createVNode("tbody", null, [
                            _createVNode("tr", _hoisted_311, [
                              _createVNode("th", _hoisted_312, _toDisplayString(_ctx.$t('total_amount')), 1),
                              _createVNode("th", _hoisted_313, _toDisplayString(_ctx.usdPriceFormate(_ctx.total)), 1)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_314,
                  (_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement)
                    ? (_openBlock(), _createBlock("p", _hoisted_315, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('company_info')) + ":", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.companyInfo && _ctx.state.data.companyInfo.acknowledgement && _ctx.state.data.companyInfo.legal_statement)
                    ? (_openBlock(), _createBlock("div", _hoisted_316, [
                        _createVNode("ul", _hoisted_317, [
                          _createVNode("li", _hoisted_318, [
                            _createVNode("button", _hoisted_319, _toDisplayString(_ctx.$t('acknowledgement')), 1)
                          ]),
                          _createVNode("li", _hoisted_320, [
                            _createVNode("button", _hoisted_321, _toDisplayString(_ctx.$t('legal_statement1')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_322, [
                          _createVNode("div", _hoisted_323, [
                            _createVNode("div", {
                              innerHTML: _ctx.state.data.companyInfo.acknowledgement
                            }, null, 8, ["innerHTML"])
                          ]),
                          _createVNode("div", _hoisted_324, [
                            _createVNode("div", {
                              innerHTML: _ctx.state.data.companyInfo.legal_statement
                            }, null, 8, ["innerHTML"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.note)
                    ? (_openBlock(), _createBlock("div", _hoisted_325, [
                        _createVNode("p", _hoisted_326, [
                          _createVNode("strong", null, _toDisplayString(_ctx.$t('note')), 1),
                          _createTextVNode(" " + _toDisplayString(_ctx.state.data.note), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.selectedChannel)
                    ? (_openBlock(), _createBlock("div", _hoisted_327, [
                        _createVNode("p", _hoisted_328, [
                          _hoisted_329,
                          _createTextVNode(" " + _toDisplayString(_ctx.state.selectedChannel.name), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.data.cropSignature || _ctx.state.data.sendarSignature)
                    ? (_openBlock(), _createBlock("div", _hoisted_330, [
                        _createVNode("div", _hoisted_331, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('signature')) + ":", 1)
                          ]),
                          _createVNode("div", _hoisted_332, [
                            _createVNode("img", {
                              src: _ctx.state.data.cropSignature ? _ctx.state.data.cropSignature : _ctx.state.data.sendarSignature,
                              alt: ""
                            }, null, 8, ["src"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_333, [
                _createVNode("button", _hoisted_334, _toDisplayString(_ctx.$t('close')), 1)
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.data.showSuccesCustomModal)
        ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
            key: 6,
            onClose: _ctx.closeSuccessCustomModal,
            showModal: _ctx.state.data.showSuccesCustomModal,
            titleMessage: _ctx.state.data.successFulMessage
          }, null, 8, ["onClose", "showModal", "titleMessage"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_335, [
        _createVNode("div", _hoisted_336, [
          _createVNode("div", _hoisted_337, [
            _createVNode("div", _hoisted_338, [
              _createVNode("div", _hoisted_339, [
                (_ctx.state.ui.isLoading.isUnitEdit)
                  ? (_openBlock(), _createBlock("h5", _hoisted_340, _toDisplayString(_ctx.$t('update_unit')), 1))
                  : (_openBlock(), _createBlock("h5", _hoisted_341, _toDisplayString(_ctx.$t('add_unit')), 1)),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  onClick: _cache[62] || (_cache[62] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args))),
                  "aria-label": "Close"
                }, [
                  _hoisted_342
                ])
              ]),
              _createVNode("div", _hoisted_343, [
                _createVNode("div", _hoisted_344, [
                  _createVNode("label", _hoisted_345, _toDisplayString(_ctx.$t('name')), 1),
                  _withDirectives(_createVNode("input", {
                    class: _ctx.state.ui.errors.validationErrorList.unitName ? 'form-control error-field' : 'form-control',
                    "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => (_ctx.state.data.unit.name = $event))
                  }, null, 2), [
                    [_vModelText, _ctx.state.data.unit.name]
                  ]),
                  (_ctx.state.ui.errors.validationErrorList.unitName)
                    ? (_openBlock(), _createBlock("p", _hoisted_346, _toDisplayString(_ctx.state.ui.errors.validationErrorList.unitName), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_347, [
                  _createVNode("label", _hoisted_348, _toDisplayString(_ctx.$t('abbreviation')), 1),
                  _withDirectives(_createVNode("input", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => (_ctx.state.data.unit.abbreviation = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.data.unit.abbreviation]
                  ]),
                  (_ctx.state.ui.errors.validationErrorList.unitAbbreviation)
                    ? (_openBlock(), _createBlock("p", _hoisted_349, _toDisplayString(_ctx.state.ui.errors.validationErrorList.unitAbbreviation), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_350, [
                (_ctx.state.ui.isLoading.isUnitEdit)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[65] || (_cache[65] = 
//@ts-ignore
(...args) => (_ctx.updateUnit && _ctx.updateUnit(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.addUnite ? _ctx.$t('loading1') : _ctx.$t('update')), 1))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[66] || (_cache[66] = 
//@ts-ignore
(...args) => (_ctx.createUnit && _ctx.createUnit(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.addUnite ? _ctx.$t('loading1') : _ctx.$t('save')), 1)),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[67] || (_cache[67] = 
//@ts-ignore
(...args) => (_ctx.addUniteClose && _ctx.addUniteClose(...args)))
                }, _toDisplayString(_ctx.$t('cancel')), 1)
              ])
            ])
          ])
        ])
      ]),
      (_ctx.state.ui.isLoading.addNewSubItem)
        ? (_openBlock(), _createBlock(_component_CreateLineItemInJobEstimation, {
            key: 7,
            onSave: _ctx.saveItem
          }, null, 8, ["onSave"]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_351, [
        _createVNode("div", _hoisted_352, [
          _createVNode("div", _hoisted_353, [
            _createVNode("div", _hoisted_354, [
              _createVNode("div", _hoisted_355, [
                _createVNode("h5", _hoisted_356, _toDisplayString(_ctx.$t('delete_subitem')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.deleteItemClose()))
                }, [
                  _hoisted_357
                ])
              ]),
              _createVNode("div", _hoisted_358, [
                _hoisted_359,
                _createVNode("span", _hoisted_360, _toDisplayString(_ctx.$t('are_you_sure')), 1)
              ]),
              _createVNode("div", _hoisted_361, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.deleteItemClose()))
                }, _toDisplayString(_ctx.$t('no')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-danger",
                  "data-dismiss": "modal",
                  onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.removeSelectedSubItem(_ctx.state.selectDeleteItem)))
                }, _toDisplayString(_ctx.$t('yes')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_362, [
        _createVNode("div", _hoisted_363, [
          _createVNode("div", _hoisted_364, [
            _createVNode("div", _hoisted_365, [
              _createVNode("div", _hoisted_366, [
                _createVNode("div", _hoisted_367, [
                  _createVNode("h5", _hoisted_368, _toDisplayString(_ctx.$t('upload_signature')), 1),
                  _createVNode("p", _hoisted_369, _toDisplayString(_ctx.$t('please_upload_valid_signature')) + ".", 1)
                ])
              ]),
              _createVNode("div", _hoisted_370, [
                _createVNode("div", _hoisted_371, [
                  _createVNode(_component_VuePictureCropper, {
                    boxStyle: {
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: '#f8f8f8',
                                    margin: 'auto',
                                },
                    img: _ctx.state.data.newUploadImge,
                    options: {
                                    viewMode: 1,
                                    dragMode: 'crop',
                                    aspectRatio: 30 / 20,
                                }
                  }, null, 8, ["img"])
                ])
              ]),
              _createVNode("div", _hoisted_372, [
                _createVNode("button", {
                  type: "button",
                  class: "btn default-btn",
                  onClick: _cache[71] || (_cache[71] = 
//@ts-ignore
(...args) => (_ctx.saveSignature && _ctx.saveSignature(...args)))
                }, [
                  _hoisted_373,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('crop')), 1)
                ]),
                _createVNode("button", {
                  class: "btn default-btn",
                  onClick: _cache[72] || (_cache[72] = 
//@ts-ignore
(...args) => (_ctx.clearCrop && _ctx.clearCrop(...args)))
                }, [
                  _hoisted_374,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('clear')), 1)
                ]),
                _createVNode("button", {
                  class: "btn default-btn",
                  onClick: _cache[73] || (_cache[73] = 
//@ts-ignore
(...args) => (_ctx.resetCrop && _ctx.resetCrop(...args)))
                }, [
                  _hoisted_375,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('reset')), 1)
                ]),
                _createVNode("button", {
                  class: "btn red-btn",
                  onClick: _cache[74] || (_cache[74] = 
//@ts-ignore
(...args) => (_ctx.hideShowUploadImageModel && _ctx.hideShowUploadImageModel(...args)))
                }, [
                  _hoisted_376,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('cancel')), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_377, [
        (_ctx.state.ui.showEditCustomerModal)
          ? (_openBlock(), _createBlock("div", _hoisted_378, [
              _createVNode("div", _hoisted_379, [
                _createVNode("div", _hoisted_380, [
                  _createVNode("div", _hoisted_381, [
                    _hoisted_382,
                    _createVNode("button", {
                      type: "button",
                      class: "close",
                      "data-dismiss": "modal",
                      "aria-label": "Close",
                      onClick: _cache[75] || (_cache[75] = 
//@ts-ignore
(...args) => (_ctx.closeEditCustomerModal && _ctx.closeEditCustomerModal(...args)))
                    }, [
                      _hoisted_383
                    ])
                  ]),
                  (_ctx.state.data.customerToEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_384, [
                        _createVNode("div", _hoisted_385, [
                          _createVNode("div", _hoisted_386, [
                            _createVNode("div", _hoisted_387, [
                              _createVNode("label", null, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('enter_email_address')), 1)
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => (_ctx.state.data.customerToEdit.user_email = $event)),
                                disabled: _ctx.state.data.customerToEdit.isEmailDisabled
                              }, null, 8, ["disabled"]), [
                                [_vModelText, _ctx.state.data.customerToEdit.user_email]
                              ]),
                              _createVNode("p", _hoisted_388, _toDisplayString(_ctx.state.data.customerToEdit.mailNotificationError), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_389, [
                            _createVNode("div", _hoisted_390, [
                              _createVNode("label", null, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('first_name')), 1)
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => (_ctx.state.data.customerToEdit.user_first_name = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.data.customerToEdit.user_first_name]
                              ]),
                              _createVNode("p", _hoisted_391, _toDisplayString(_ctx.state.data.customerToEdit.firstNameNotificationError), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_392, [
                            _createVNode("div", _hoisted_393, [
                              _createVNode("label", null, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('last_name')), 1)
                              ]),
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => (_ctx.state.data.customerToEdit.user_last_name = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.state.data.customerToEdit.user_last_name]
                              ]),
                              _createVNode("p", _hoisted_394, _toDisplayString(_ctx.state.data.customerToEdit.lastNameNotificationError), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_395, [
                            _createVNode("div", _hoisted_396, [
                              _createVNode("label", _hoisted_397, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('phone_number')), 1)
                              ]),
                              _createVNode(_component_AppPhoneNumberInput, {
                                modelValue: _ctx.state.data.customerToEdit.user_mobile_number,
                                "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => (_ctx.state.data.customerToEdit.user_mobile_number = $event)),
                                disabled: _ctx.state.data.customerToEdit.isPhoneDisabled
                              }, null, 8, ["modelValue", "disabled"]),
                              _createVNode("p", _hoisted_398, _toDisplayString(_ctx.state.data.customerToEdit.smsNotificationError), 1)
                            ])
                          ]),
                          _createVNode("div", _hoisted_399, [
                            _createVNode("div", _hoisted_400, [
                              _createVNode("label", null, [
                                _createVNode("small", null, _toDisplayString(_ctx.$t('notify_by')), 1)
                              ]),
                              _createVNode("div", _hoisted_401, [
                                _createVNode("div", _hoisted_402, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: "true",
                                    "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event: any) => (_ctx.state.data.customerToEdit.mailNotification = $event))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.state.data.customerToEdit.mailNotification]
                                  ]),
                                  _createVNode("label", _hoisted_403, _toDisplayString(_ctx.$t('email')), 1)
                                ]),
                                _createVNode("div", _hoisted_404, [
                                  _withDirectives(_createVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: "true",
                                    "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => (_ctx.state.data.customerToEdit.smsNotification = $event))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.state.data.customerToEdit.smsNotification]
                                  ]),
                                  _createVNode("label", _hoisted_405, _toDisplayString(_ctx.$t('sms')), 1)
                                ])
                              ]),
                              _createVNode("p", _hoisted_406, _toDisplayString(_ctx.state.data.customerToEdit.mailNotificationError), 1)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_407, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[82] || (_cache[82] = ($event: any) => (_ctx.updateSelectCustomer(_ctx.customerIndex))),
                      disabled: !_ctx.state.data.customerToEdit.mailNotification && !_ctx.state.data.customerToEdit.smsNotification
                    }, " Update ", 8, ["disabled"]),
                    _createVNode("button", {
                      type: "button",
                      class: "btn secondary-btn",
                      "data-dismiss": "modal",
                      onClick: _cache[83] || (_cache[83] = 
//@ts-ignore
(...args) => (_ctx.closeEditCustomerModal && _ctx.closeEditCustomerModal(...args)))
                    }, " Cancel ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_408, [
        _createVNode("div", _hoisted_409, [
          _createVNode("div", _hoisted_410, [
            _createVNode("div", _hoisted_411, [
              _createVNode("div", _hoisted_412, [
                _createVNode("h5", _hoisted_413, _toDisplayString(_ctx.$t('add_company_information')), 1),
                _createVNode("button", {
                  type: "button",
                  class: "close",
                  "data-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[84] || (_cache[84] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                }, [
                  _hoisted_414
                ])
              ]),
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.createCompanyIfno,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_415, [
                _createVNode("div", _hoisted_416, [
                  _createVNode("div", _hoisted_417, [
                    (!_ctx.state.ui.isLoading.isCompanyEdit)
                      ? (_openBlock(), _createBlock("div", _hoisted_418, [
                          _createVNode("label", _hoisted_419, _toDisplayString(_ctx.$t('company_name')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => (_ctx.state.data.companyInfo.company_name = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_name]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (!_ctx.state.ui.isLoading.isCompanyEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_420, [
                        _createVNode("div", _hoisted_421, [
                          _createVNode("label", _hoisted_422, _toDisplayString(_ctx.$t('phone_number')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => (_ctx.state.data.companyInfo.company_phone_number = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_phone_number]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.state.ui.isLoading.isCompanyEdit)
                    ? (_openBlock(), _createBlock("div", _hoisted_423, [
                        _createVNode("div", _hoisted_424, [
                          _createVNode("label", _hoisted_425, _toDisplayString(_ctx.$t('email_address')), 1),
                          _withDirectives(_createVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => (_ctx.state.data.companyInfo.company_email = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.state.data.companyInfo.company_email]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_426, [
                  _createVNode("label", _hoisted_427, _toDisplayString(_ctx.$t('company_logo')), 1),
                  (_ctx.state.data.details.logo)
                    ? (_openBlock(), _createBlock("div", _hoisted_428, [
                        _createVNode("img", {
                          src: _ctx.state.data.details.logo.file
                                        ? _ctx.state.data.details.logo.file
                                        : _ctx.state.data.details.logo
                                        ,
                          alt: ""
                        }, null, 8, ["src"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_429, [
                    _createVNode("div", _hoisted_430, [
                      _createVNode("button", _hoisted_431, [
                        _hoisted_432,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('upload')), 1)
                      ]),
                      _createVNode("input", {
                        type: "file",
                        accept: "image/png, image/jpeg",
                        id: "profileUpdate",
                        onChange: _cache[88] || (_cache[88] = ($event: any) => (_ctx.uploadLogo($event)))
                      }, null, 32)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_433, [
                  _createVNode("label", _hoisted_434, _toDisplayString(_ctx.$t('add_acknowledgement')), 1),
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.state.data.details.acknowledgement,
                    "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => (_ctx.state.data.details.acknowledgement = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_435, [
                  _createVNode("label", _hoisted_436, _toDisplayString(_ctx.$t('add_conduct_of_contract')), 1),
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.state.data.details.legal_statement,
                    "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => (_ctx.state.data.details.legal_statement = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createVNode("div", _hoisted_437, [
                (_ctx.state.ui.isLoading.isCompanyEdit)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn default-btn d-inline-block",
                      onClick: _cache[91] || (_cache[91] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                    }, _toDisplayString(_ctx.$t('update')), 1))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn default-btn d-inline-block",
                      onClick: _cache[92] || (_cache[92] = 
//@ts-ignore
(...args) => (_ctx.createCompanyIfno && _ctx.createCompanyIfno(...args)))
                    }, _toDisplayString(_ctx.$t('save_changes')), 1)),
                _createVNode("button", {
                  type: "button",
                  class: "btn secondary-btn",
                  "data-dismiss": "modal",
                  onClick: _cache[93] || (_cache[93] = 
//@ts-ignore
(...args) => (_ctx.hideCreateCompanyModel && _ctx.hideCreateCompanyModel(...args)))
                }, _toDisplayString(_ctx.$t('close')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showChatChannelModal)
      ? (_openBlock(), _createBlock(_component_ToDoChatChannelModel, {
          key: 0,
          showPhaseChannel: _ctx.state.data.showChatChannelModal,
          selectedChannel: _ctx.state.selectedChannel,
          onClose: _ctx.hideChatChannel,
          onChannelSelected: _ctx.handleChannelSelection
        }, null, 8, ["showPhaseChannel", "selectedChannel", "onClose", "onChannelSelected"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSignaturePad)
      ? (_openBlock(), _createBlock(_component_SignaturePadModal, {
          key: 1,
          onClose: _ctx.hideSignaturePad,
          onUploadSignature: _ctx.uploadSignature,
          showModal: _ctx.state.data.showSignaturePad,
          from: 'estimation'
        }, null, 8, ["onClose", "onUploadSignature", "showModal"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSignatureUpload)
      ? (_openBlock(), _createBlock(_component_SignatureUploadModal, {
          key: 2,
          showModal: _ctx.state.data.showSignatureUpload,
          signatureFile: _ctx.state.data.uploadSignatureFile,
          from: 'estimation',
          onClose: _ctx.hideSignatureUpload,
          onUploadSignature: _ctx.uploadSignature
        }, null, 8, ["showModal", "signatureFile", "onClose", "onUploadSignature"]))
      : _createCommentVNode("", true)
  ], 64))
})